/**
 * Обработчик выделения текста в определениях для поиска
 * Использует mouseup для правильной обработки выделения текста
 */

(function() {
  'use strict';

  /**
   * Получает текущий язык из глобального объекта
   */
  function getCurrentLang() {
    return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
  }

  /**
   * Лемматизирует слово через глобальный объект
   */
  function lemmatizeWord(word, lang) {
    return window.SEARCH_LEMMATIZATION ? window.SEARCH_LEMMATIZATION.lemmatizeWord(word, lang) : word;
  }

  /**
   * Инициализирует обработчик выделения текста
   */
  function initTextSelectionHandler() {
    // Переменная для отслеживания кнопки мыши в mousedown
    var lastMouseDownButton = -1;

    $(document).on('mousedown', '.descr', function(e) {
      if (e.target.closest('.revision-dialog')) return;
      lastMouseDownButton = (e.originalEvent && e.originalEvent.button !== undefined) ? e.originalEvent.button : e.button;
    });

    // Обработчик клика на текст определения для поиска выделенного слова
    // Используем mouseup вместо click, чтобы правильно обработать выделение текста
    $(document).on('mouseup', '.descr', function(e) {
      if (e.target.closest('.revision-dialog')) return;
      // Не обрабатываем, если кликнули на тег <r> или внутри него - для них своя логика в search.js
      if (e.target.closest('r')) {
        return;
      }
      // Клики по свёрнутым toggle-иконкам (источники/merged refs) не должны инициировать поиск слова
      if (e.target.closest('.d-src-cluster-toggle, .d-ref-collapsed-toggle')) {
        return;
      }

      // ПРОВЕРКА КНОПКИ МЫШИ:
      // Нам нужна ТОЛЬКО левая кнопка мыши (button === 0) без клавиш-модификаторов
      var button = (e.originalEvent && e.originalEvent.button !== undefined) ? e.originalEvent.button : e.button;
      var hasModifiers = e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;

      // Не обрабатываем, если:
      // 1. Это не левая кнопка мыши (проверяем и mousedown, и mouseup)
      // 2. Нажаты клавиши-модификаторы (Ctrl, Cmd, Shift, Alt)
      // 3. Тройной клик и выше (выделение абзаца — не наш кейс)
      if (button !== 0 || lastMouseDownButton !== 0 || hasModifiers || e.detail > 2) {
        return;
      }
      
      // Клик по слову внутри статьи = потенциальное прояснение.
      // Ставим PENDING_PARENT_ID чтобы следующий поиск (через double-click,
      // click-to-search или кнопку поиска) стал дочерним в иерархии.
      if (window.CURRENT_HISTORY_ID) {
        window.PENDING_PARENT_ID = window.CURRENT_HISTORY_ID;
        window.PENDING_PARENT_TS = Date.now();
      }

      // Небольшая задержка, чтобы браузер успел выделить текст
      setTimeout(function() {
        var currentLang = getCurrentLang();
        var s = window.getSelection();
        var selectedText = s.toString().trim();
        
        // Если ничего не выделено, пытаемся выделить слово под курсором
        if (!selectedText) {
          try {
            s.modify('extend','backward','word');
            var b = s.toString();
            s.modify('extend','forward','word');
            var a = s.toString();
            s.modify('move','forward','character');
            // Получаем полное выделенное слово без обрезки
            selectedText = (b + a).trim();
          } catch (err) {
            // Если не получилось выделить, выходим
            return;
          }
        }
        
        if (selectedText && selectedText.length > 0) {
          // Selection.toString() is already plain text. Parsing it as HTML
          // could execute a literal example such as an escaped img onerror.
          
          // Убираем только множественные пробелы, но не трогаем сам текст
          selectedText = selectedText.replace(/\s+/g, ' ').trim();
          
          // Проверяем, что остался текст
          if (selectedText && selectedText.length > 0) {
            // Лемматизируруем слово (лемматизация сама обработает окончания и знаки препинания)
            var lemmatized = lemmatizeWord(selectedText, currentLang);
            
            // Заменяем текст в поле поиска (полная замена)
            var searchInput = document.getElementById('search');
            if (searchInput) {
              // Логика быстрого поиска:
              // Если в строке поиска уже стоит то же самое слово - запускаем поиск
              if (searchInput.value.trim() === lemmatized) {
                if (window.SEARCH && typeof window.SEARCH.performSearch === 'function') {
                  window.SEARCH.performSearch();
                }
              } else {
                // Снимаем подсветку с предыдущих слов (включая развертывание временных span)
                var prevActive = document.querySelectorAll('.active-term');
                prevActive.forEach(function(el) {
                  if (el.tagName.toLowerCase() === 'span') {
                    // Если это временный span, возвращаем текст
                    var parent = el.parentNode;
                    while (el.firstChild) parent.insertBefore(el.firstChild, el);
                    parent.removeChild(el);
                    parent.normalize(); // Склеиваем текстовые узлы обратно
                  } else {
                    // Если это существующий тег (r, b, i), просто снимаем класс
                    el.classList.remove('active-term');
                  }
                });

                // Подсвечиваем новое слово
                // Если кликнули по существующему тегу (кроме r, который обработан в search.js)
                var targetTag = e.target;
                if (targetTag && targetTag !== e.currentTarget && ['B', 'I', 'STRONG', 'EM'].includes(targetTag.tagName)) {
                  targetTag.classList.add('active-term');
                } else if (s.rangeCount > 0) {
                  // Если это просто текст, оборачиваем в span
                  try {
                    var range = s.getRangeAt(0);
                    var span = document.createElement('span');
                    span.className = 'active-term';
                    range.surroundContents(span);
                  } catch (err) {
                    console.log('Could not surround contents with active-term span');
                  }
                }

                // Слово новое - только вставляем в поле
                searchInput.value = lemmatized;
                
                // Фокусируемся на поле поиска (только для десктопа)
                // На мобильных фокус вызывает открытие клавиатуры, что неудобно при клике по слову
                var isMobile = window.SEARCH_UTILS && window.SEARCH_UTILS.isMobileDevice && window.SEARCH_UTILS.isMobileDevice();
                if (!isMobile) {
                  searchInput.focus();
                }

                // Если включена настройка поиска одним кликом - запускаем поиск
                var isClickSearchEnabled = window.SETTINGS_CLICK_SEARCH || (window.SEARCH_UTILS && window.SEARCH_UTILS.isClickSearchEnabled && window.SEARCH_UTILS.isClickSearchEnabled());
                
                if (isClickSearchEnabled) {
                  if (window.SEARCH && typeof window.SEARCH.performSearch === 'function') {
                    // Небольшая задержка, чтобы UI успел обновиться
                    setTimeout(function() {
                      window.SEARCH.performSearch();
                    }, 50);
                  }
                }
              }
              // Очищаем выделение
              s.removeAllRanges();
            }
          }
        }
      }, 10);
    });
  }

  // Инициализируем при загрузке модуля
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTextSelectionHandler);
  } else {
    initTextSelectionHandler();
  }
})();
